import { AppRoutingModule } from "./app-routing.module";
import { BrowserModule } from "@angular/platform-browser";
import { BrowserAnimationsModule } from "@angular/platform-browser/animations";
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatCardModule } from "@angular/material/card";
import { MatToolbarModule } from "@angular/material/toolbar";
import { MatButtonModule } from "@angular/material/button";
import { MatIconModule } from '@angular/material/icon';
import { MatSidenavModule } from "@angular/material/sidenav";
import { FlexLayoutModule } from "@angular/flex-layout";
import { LocationStrategy, PathLocationStrategy } from '@angular/common';
import { HTTP_INTERCEPTORS, HttpClient, HttpClientModule } from '@angular/common/http';
import { MatTableModule } from '@angular/material/table';
import { MatDividerModule } from '@angular/material/divider';
import { MatTabsModule } from '@angular/material/tabs';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatStepperModule } from '@angular/material/stepper';
import { MatDialogModule } from '@angular/material/dialog';
import { MatListModule } from '@angular/material/list';
import { MatRadioModule } from '@angular/material/radio';
import { MatPaginatorModule } from '@angular/material/paginator';
import { STEPPER_GLOBAL_OPTIONS } from '@angular/cdk/stepper';
import { MatTableExporterModule } from 'mat-table-exporter';
import { ReactiveFormsModule } from '@angular/forms';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { NbThemeModule, NbLayoutModule, NbDatepickerModule, NbToastrModule } from '@nebular/theme';
import { NbEvaIconsModule } from '@nebular/eva-icons';
import { NbAuthJWTToken, NbAuthModule, NbPasswordAuthStrategy } from '@nebular/auth';
import { OverlayContainer } from '@angular/cdk/overlay';
import { MatSelectModule } from '@angular/material/select';
import { NgxSliderModule } from '@angular-slider/ngx-slider';
import { CdkAccordionModule } from '@angular/cdk/accordion';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatCheckboxModule, } from '@angular/material/checkbox';
import { NgxEchartsModule } from 'ngx-echarts';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatNativeDateModule } from '@angular/material/core';
import { MatSortModule } from "@angular/material/sort";
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { NbCardModule } from "@nebular/theme";
import { NbCalendarModule } from "@nebular/theme";
import { NbCalendarRangeModule } from "@nebular/theme";
import { AuthInterceptor } from "./auth/auth.interceptor";

import { AppComponent } from "./app.component";
import { OverviewComponent } from './pages/overview/overview.component';
import { AnalyticsComponent } from './pages/analytics/analytics.component';
import { ControlPanelComponent } from './pages/control-panel/control-panel.component';
import { AlertsRecommendationsComponent } from './pages/alerts-recommendations/alerts-recommendations.component';
import { PreferencesComponent } from './pages/preferences/preferences.component';
import { EnergyFlowComponent } from './components/charts/energy-flow/energy-flow.component';
import { MyAccountComponent } from './pages/my-account/my-account.component';
import { AboutComponent } from "./pages/about/about.component";
import { ToolbarComponent } from './components/toolbar/toolbar.component';
import { SidenavComponent } from "./components/sidenav/sidenav.component";
import { TopologyGraphComponent } from './components/charts/topology-graph/topology-graph.component';
import { CostSavingsPerDayComponent } from './components/charts/cost-savings-per-day/cost-savings-per-day.component';
import { EnergyConsumptionPerDeviceComponent } from "./components/charts/energy-consumption-per-device/energy-consumption-per-device.component";
import { ScoresBreakdownComponent } from './components/charts/scores-breakdown/scores-breakdown.component';
import { DrEventsDetailsComponent } from "./components/modals/dr-events-details/dr-events-details.component";
import { DeviceDetailsComponent } from "./components/modals/device-details/device-details.component";
import { NotificationDetailsComponent } from './components/modals/notification-details/notification-details.component';
import { SriDetailsComponent } from './components/modals/sri-details/sri-details.component';
import { DefaultLayoutComponent } from "./layouts/default-layout/default-layout.component";
import { AuthLayoutComponent } from "./layouts/auth-layout/auth-layout.component";
import { HomeNotificationsTableComponent } from './components/tables/home-notifications-table/home-notifications-table.component';
import { DrEventsTableComponent } from "./components/tables/dr-events-table/dr-events-table.component";
import { DevicesTableComponent } from './components/tables/devices-table/devices-table.component';
import { GamificationComponent } from "./pages/gamification/gamification.component";

import { environment } from "src/environments/environment";
import { AuthGuard } from './auth/auth-guard.service';
import { MyOverlayContainer } from "./services/customOverlay";
import { httpLoaderFactory } from "./services/httpLoaderFactory";
import { NotificationService } from "./services/unreadMesssages.service";


@NgModule({
  declarations: [AppComponent, OverviewComponent, AnalyticsComponent, PreferencesComponent,
    ControlPanelComponent, AlertsRecommendationsComponent, EnergyFlowComponent, AboutComponent,
    MyAccountComponent, ToolbarComponent, SidenavComponent, DrEventsDetailsComponent, DeviceDetailsComponent,
    EnergyConsumptionPerDeviceComponent, TopologyGraphComponent,
    CostSavingsPerDayComponent, DrEventsTableComponent, GamificationComponent, ScoresBreakdownComponent,
    DefaultLayoutComponent, AuthLayoutComponent, SriDetailsComponent, NotificationDetailsComponent, HomeNotificationsTableComponent, DevicesTableComponent
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    BrowserAnimationsModule,
    NgxEchartsModule,
    MatCheckboxModule,
    FormsModule,
    MatSortModule,
    MatDatepickerModule,
    MatNativeDateModule,
    MatFormFieldModule,
    MatInputModule,
    MatCardModule,
    ReactiveFormsModule,
    MatToolbarModule,
    MatButtonModule,
    FlexLayoutModule,
    MatIconModule,
    MatTableModule,
    MatTooltipModule,
    MatDividerModule,
    MatTabsModule,
    CdkAccordionModule,
    NgxSliderModule,
    MatProgressBarModule,
    MatSelectModule,
    MatStepperModule,
    MatSlideToggleModule,
    HttpClientModule,
    MatRadioModule,
    MatDialogModule,
    MatListModule,
    MatPaginatorModule,
    MatTableExporterModule,
    ReactiveFormsModule,
    MatProgressSpinnerModule,
    MatSidenavModule,
    MatSnackBarModule,
    NbCardModule,
    NbCalendarModule,
    NbCalendarRangeModule,
    NbLayoutModule,
    NbEvaIconsModule,
    NbToastrModule.forRoot(),
    NbDatepickerModule.forRoot(),
    NbThemeModule.forRoot({ name: 'default' }),
    NbAuthModule.forRoot({
      strategies: [
        NbPasswordAuthStrategy.setup({
          name: 'email',
          baseEndpoint: environment.auth.endpoints.base,
          login: {
            defaultErrors: ['Something went wrong, please try again.'],
            defaultMessages: ['You are successfully logged in'],
            redirect: {
              success: 'pages/dashboard',
              failure: null, // stay on the same page
            },
          },
          register: {
            defaultErrors: ['Something went wrong, please try again.'],
            defaultMessages: ['You are successfully registered and can login'],
            redirect: {
              success: 'auth/login',
              failure: null,
            },
          },
          logout: {
            defaultErrors: ['Something went wrong, please try again.'],
            defaultMessages: ['You are successfully logged out'],
            redirect: {
              success: 'auth/login',
              failure: null,
            },
          },
          requestPass: {
            endpoint: 'auth/request-password',
            method: 'post',
            redirect: {
              success: '/',
              failure: null,
            },
            defaultErrors: ['Something went wrong, please try again.'],
            defaultMessages: ['Reset password instructions have been sent to your email.'],
          },
          resetPass: {
            endpoint: 'auth/reset-password',
            method: 'put',
            redirect: {
              success: '/',
              failure: null,
            },
            resetPasswordTokenKey: 'reset_password_token',
            defaultErrors: ['Something went wrong, please try again.'],
            defaultMessages: ['Your password has been successfully changed.'],
          },
          token: {
            class: NbAuthJWTToken,
            key: 'data.access_token',
          },
        }),
      ],
      forms: {
        login: {
          redirectDelay: 0,
        },
        logout: {
          redirectDelay: 0,
        },
      },
    }),
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: httpLoaderFactory,
        deps: [HttpClient]
      }
    })
  ],
  entryComponents: [DeviceDetailsComponent, DrEventsDetailsComponent, SriDetailsComponent, NotificationDetailsComponent],
  providers: [
    { provide: LocationStrategy, useClass: PathLocationStrategy },
    { provide: STEPPER_GLOBAL_OPTIONS, useValue: { displayDefaultIndicatorType: false } },
    AuthGuard,
    { provide: NotificationService, useClass: NotificationService },
    { provide: OverlayContainer, useClass: MyOverlayContainer },
    { provide: HTTP_INTERCEPTORS, useClass: AuthInterceptor, multi: true }
  ],
  bootstrap: [AppComponent],
})

export class AppModule { }
